export const DROPDOWN_CONTROL_PREFIX = "DropdownControl";

export const DROPDOWN_CONTROL_CLASSES = {
  visibleInput: `${DROPDOWN_CONTROL_PREFIX}-visibleInput`,
  paper: `${DROPDOWN_CONTROL_PREFIX}-paper`,
};
